<template>
  <v-layout row wrap>

    <v-flex xs12 class="text-xs-left blue--text">
      <div>We just sent an OTP code to <span class="text-primary font-weight-bold">{{ phone }}</span></div>
    </v-flex>

    <v-flex d-flex xs12 mt-4>
      <v-layout row wrap align-center class="text-xs-left">
        <v-flex xs12 class="pr-4">
          Enter the code here:
        </v-flex>

        <v-flex d-flex xs12 >
          <v-text-field
            @keyup="changedInput=true"
            @keyup.enter="validateOtp"
            v-validate="'required|length:4'"
            :error-messages="errors.collect('otp')"
            data-vv-name="otp"
            data-vv-validate-on="blur"
            v-model="otp"
            label="Code"
            type="tel"
          ></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 class="mt-0">
          <v-btn @click="validateOtp"
                 :disabled="!changedInput || otp.length !== 4"
                 :loading="loading" class="ml-0 mr-0 "
                 color="success">Confirm code</v-btn>
        </v-flex>
        <v-flex d-flex xs12>
          <v-btn class="mr-0 ml-0" @click="goToSignupStep(page, 'confirm-my-phone')" color="primary">&#8592; Back</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import crypto from '@/mixins/crypto'
  import common from '@/mixins/common'
  import {mapGetters, mapMutations} from 'vuex'

  export default {
    name: 'PhoneCodeVerification',
    data () {
      return {
        loading: false,
        changedInput: false,
        otp: '',
        phone: '',
        errorMsg: 'Please enter 4 digit code',
        dictionary: {
          custom: {
            otp: {
              required: () => this.errorMsg,
              length: 'Code must be 4 Digits'
            }
          }
        }
      }
    },
    props: {
      page: {
        default: 'SignUp',
        type: String
      }
    },
    mounted () {
      this.$validator.localize('en', this.dictionary)
      this.phone = this.getUserDetails.phone_object.formatted
    },
    computed: {
      ...mapGetters('registration', ['getUserDetails'])
    },
    methods: {
      ...mapMutations('registration', [
        'setUser'
      ]),
      validateOtp () {
        console.log(this.errors.otp)
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading = true
            const otpId = this.getUserDetails.phone_otp_id
            this.$http({
              url: process.env.API_URL + '/ws/userservice/verify/otp/' + otpId + '/entered/' + this.otp,
              method: 'GET'
            }).then((res) => {
              if (res.data.otpMatch === true) {
                this.setUser({...this.getUserDetails, phone_verified: true})
                this.$router.push({name: this.page, params: {step: 'confirm-name'}})
              } else {
                this.setUser({...this.getUserDetails, phone_verified: false})
                this.loading = false
                this.errors.add({
                  field: 'otp',
                  msg: 'Invalid code'
                })
              }
            })
          }
        })
      }
    },
    mixins: [crypto, common]
  }
</script>


<style scoped>
  .partitioned {
    padding-left: 10px;
    letter-spacing: 42px;
    border: 0;
    background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);
    background-position: bottom;
    background-size: 50px 1px;
    background-repeat: repeat-x;
    background-position-x: 35px;
    width: 230px;
    min-width:230px;
    outline-style:none;
    box-shadow:none;
    border-color:transparent;
  }

  #divInner{
    left: 0;
    position: sticky;
  }

  #divOuter{
    width:190px;
    overflow:hidden
  }
</style>



// WEBPACK FOOTER //
// src/components/views/sign-up/PhoneCodeVerification.vue